import { createFileRoute, redirect } from "@tanstack/react-router";
import { CustomPagePage } from "@/app/partner/pages/settings/custom-page";
import { canAccessRoute } from "@/lib/auth";

export const Route = createFileRoute("/flex/dashboard/custom-page")({
	beforeLoad: async ({ context }) => {
		const { partner } = context;
		const access = canAccessRoute(partner, "customPage");

		if (!access.allowed) {
			throw redirect({ to: "/flex/dashboard" });
		}
	},
	component: CustomPagePage,
});
